import api from '../../api/axios';

export const getTags = async () => {
  try {
    const { data } = await api.get(`/api/tags?api_version=v2`);
    return { isError: false, data };
  } catch (error) {
    throw { isError: true, error };
  }
};

export const getWords = async (payload) => {
  try {
    // Cloning the payload so the original references used by the context won't be mutated
    const clonedPayload = { ...payload };
    const clonedBasic = { ...clonedPayload.basic };
    const clonedGenus = [...clonedBasic.Genus];

    if (clonedGenus.length === 3) {
      clonedGenus.push('kein');
      clonedBasic.Genus = clonedGenus;
      clonedPayload.basic = clonedBasic;
    }

    const { data } = await api.post(`/api/words/search`, clonedPayload);
    return { isError: false, data };
  } catch (error) {
    throw { isError: true, error };
  }
};

export const getSelectedWords = async (set, patientID, setId) => {
  try {
    const { data } = await api.get(
      `/api/patients/${patientID}/${set}/${setId}`,
    );
    return { isError: false, data };
  } catch (error) {
    throw { isError: true, error };
  }
};
